<template>
    <div class="hello">
        <h1>{{ $t('site.nav.news') }}</h1>
        <elv-release-notes></elv-release-notes>

        <br/><br/>
        <mail-chimp-signup></mail-chimp-signup>
    </div>
</template>

<script>
    import ElvReleaseNotes from "@/components/ElvReleaseNotes"
    import MailChimpSignup from "@/components/MailChimpSignup"

    export default {
        components: {
            MailChimpSignup,
            ElvReleaseNotes},
        name: 'Thanks',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/news.vue